window.debug = false;
window.log = (...args) => { if (window.debug) console.log(...args); };

window.page = {

  all: {

    init: () => {
      window.page.all.moveCmodals();
      window.page.all.addListeners();
    },

    moveCmodals: () => {
      const cmodals_wrpper_el = document.querySelector('.cmodals');
      const cmodals_el = document.querySelectorAll('.cmodal');
      
      if (cmodals_wrpper_el && cmodals_el.length) {
        cmodals_el.forEach((cmodal) => {
          cmodals_wrpper_el.appendChild(cmodal);
        });
      }
    },

    addListeners: () => {
      const cmodal_open_buttons = document.querySelectorAll('[data-action-open-cmodal]:not(.event_is_set)');
      if (cmodal_open_buttons.length) {
        cmodal_open_buttons.forEach((button)=>{
          button.addEventListener('click', () => {
            const cmodal_id = button.getAttribute('data-action-open-cmodal');
            const cmodal_el = document.querySelector(`[data-cmodal-id="${cmodal_id}"]`);
            if (cmodal_el) {
              document.body.classList.add('cmodal_is_open');
              cmodal_el.classList.add('is_active');
            }
          });
          button.classList.add('event_is_set');
        });
      }
      
      const cmodal_close_buttons = document.querySelectorAll('.cmodal .box__close:not(.event_is_set)');
      if (cmodal_close_buttons.length) {
        cmodal_close_buttons.forEach((button)=>{
          button.addEventListener('click', () => {
            button.closest('.cmodal').classList.remove('is_active');
            document.body.classList.remove('cmodal_is_open');
          });
          button.classList.add('event_is_set');
        });
      }
    }
  },

  product: {

    init: () => {
      const tpl = document.querySelector('[data-tpl^="product"]');

      if (tpl) {
        const product_qty_input = document.querySelector('.product-single__wrapper input[name="quantity"]');
        const product_box_qty_names = document.querySelectorAll('.product-single__wrapper .product_qty_group .box__qty__name__value');

        if (product_qty_input && product_box_qty_names.length) {
          let product_qty_array = [];
          product_box_qty_names.forEach((name) => {
            product_qty_array.push(parseFloat(name.innerHTML));
          });
          const product_qty_min = product_qty_array.length ? Math.min(...product_qty_array) : null;

          if (product_qty_min) {
            window.page_product_product_qty_min = product_qty_min;
            // product_qty_input.min = product_qty_min;
            // if (product_qty_input.value < product_qty_min) {
            //   product_qty_input.value = product_qty_min;
            // }

            const checked_tier_value_el = document.querySelector('.product-single__wrapper .product_qty_group [type="radio"]:checked')?.closest('.radio__button')?.querySelector('.box__qty__name__value');
            const default_qty = checked_tier_value_el ? parseFloat(checked_tier_value_el.innerHTML) : product_qty_min;

            if (default_qty) {
              product_qty_input.value = default_qty;
            }
          }
        }

        setTimeout(() => {
          window.page.product.detectVariantFromUrl();
        }, 100);
        
        window.page.product.updateProductQtyGroup();
        window.page.product.addListeners();
      }
    },

    detectVariantFromUrl: () => {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      
      if (!variantId) return;

      let productData = window.cdrawer_main_product_data?.product;
      
      if (!productData) {
        const main_product_data_e = document.querySelector('#main_product_data');
        if (main_product_data_e) {
          try {
            productData = JSON.parse(main_product_data_e.innerHTML).product;
          } catch(e) {
            console.error('Failed to parse main_product_data', e);
            return;
          }
        }
      }
      
      if (!productData) {
        console.warn('Product data not available for detectVariantFromUrl');
        return;
      }

      const variant = productData.variants.find(v => v.id == variantId);
      
      if (!variant) {
        console.warn('Variant not found:', variantId);
        return;
      }

      // console.log('Detected variant from URL:', variant);

      ['option1', 'option2', 'option3'].forEach((optionKey) => {
        const optionValue = variant[optionKey];
        if (!optionValue) return;
        
        // console.log(`Looking for ${optionKey}:`, optionValue);
        
        const radio = document.querySelector(
          `.product-single__wrapper input[type="radio"][data-index="${optionKey}"][value="${optionValue}"]`
        );
        
        if (radio) {
          const label = radio.closest('.radio__button')?.querySelector('label');
          if (label) {
            // console.log('Clicking label for:', optionValue);
            label.click();
          }
        } else {
          const popout_input = document.querySelector(
            `.product-single__wrapper [data-popout-input][data-index="${optionKey}"]`
          );
          const popout_option = popout_input?.closest('popout-select')?.querySelector(
            `[data-popout-option][data-value="${optionValue}"]`
          );

          if (popout_option) {
            popout_option.click();
          } else {
            console.warn('Radio not found for', optionKey, optionValue);
          }
        }
      });
    },

    addListeners: () => {
      const labels = document.querySelectorAll('.product-single__wrapper .radio__buttons label');
      const product_qty_input = document.querySelector('.product-single__wrapper input[name="quantity"]');

      if (labels.length) {
        labels.forEach((label) => {
          label.addEventListener('click', () => {
            const inside_product_qty_group = label.closest('.product_qty_group') ? true : false;

            if (inside_product_qty_group) {
              window.page.product.updateProductFormQty(label.querySelector('.box__qty__name__value').innerHTML);
            }

            setTimeout(()=>{
              window.page.product.updateProductQtyGroup();
            }, 100);
          });
        });
      }

      const popout_option_inputs = document.querySelectorAll('.product-single__wrapper .product__selectors [data-popout-input][data-single-option-selector]');
      popout_option_inputs.forEach((input) => {
        input.addEventListener('change', () => {
          setTimeout(()=>{
            window.page.product.updateProductQtyGroup();
          }, 100);
        });
      });

      if (product_qty_input) {
        let isUpdating = false;
        
        const checkAndUpdateQty = () => {
          if (isUpdating) return;
          isUpdating = true;

          // if (window.page_product_product_qty_min) {
          //   if (product_qty_input.value < window.page_product_product_qty_min) {
          //     product_qty_input.value = window.page_product_product_qty_min;
          //     const event = new Event('change', { bubbles: true });
          //     product_qty_input.dispatchEvent(event);
          //   }
          // }
          window.page.product.updateQtyVariant(product_qty_input.value);
          window.page.product.validateQtyAgainstTier();

          setTimeout(() => { isUpdating = false; }, 100);
        };

        if (window.page_product_product_qty_min) {
          product_qty_input.addEventListener('input', checkAndUpdateQty);
          product_qty_input.addEventListener('change', checkAndUpdateQty);
        }

        document.addEventListener('click', (e) => {
          if (e.target.closest('.radio__button')) {
            setTimeout(checkAndUpdateQty, 50);
          }
        });

        checkAndUpdateQty();
      }
    },

    getInventoryQuantityByVariantId(variant_id) {
      const variants = window.cdrawer_main_product_data?.product?.variants || [];
      const found = variants.find(v => v.id === parseFloat(variant_id));
      return found ? found.inventory_quantity : false;
    },

    pulseElement: (el) => {
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.remove('cpulse');
      void el.offsetWidth;
      el.classList.add('cpulse');
      setTimeout(() => { el.classList.remove('cpulse'); }, 1200);
    },

    validateQtyAgainstTier: () => {
      const qty_input = document.querySelector('.product-single__wrapper input[name="quantity"]');
      const checked_tier_value_el = document.querySelector('.product__form .product_qty_group [type="radio"]:checked')?.closest('.radio__button')?.querySelector('.box__qty__name__value');
      const submit_buttons_wrapper = document.querySelector('.product-single__details .product__submit__buttons');

      if (!qty_input || !checked_tier_value_el || !submit_buttons_wrapper) return;

      const qty = parseFloat(qty_input.value);
      const tier = parseFloat(checked_tier_value_el.innerHTML);
      const below_tier = !isNaN(qty) && !isNaN(tier) && qty < tier;

      submit_buttons_wrapper.classList.toggle('qty_below_tier', below_tier);
    },

    updateProductQtyGroup: () => {
      // console.log('updateProductQtyGroup');
      function fixEncoding(str) {
        try {
          return decodeURIComponent(escape(str));
        } catch (e) {
          return str;
        }
      }

      function getPriceByOption(box_json, option1, option2, option3) {
        const fixedOption1 = option1 ? fixEncoding(option1) : undefined;
        const fixedOption2 = option2 ? fixEncoding(option2) : undefined;
        const fixedOption3 = option3 ? fixEncoding(option3) : undefined;

        const match = box_json.find(item => {
          const matchOption1 = typeof fixedOption1 === 'undefined' || fixEncoding(item.option1) === fixedOption1;
          const matchOption2 = typeof fixedOption2 === 'undefined' || fixEncoding(item.option2) === fixedOption2;
          const matchOption3 = typeof fixedOption3 === 'undefined' || fixEncoding(item.option3) === fixedOption3;
          return matchOption1 && matchOption2 && matchOption3;
        });

        return match ? {"price":match.price, "price_money": match.price_money} : null;
      }

      const option_values = {};
      document.querySelectorAll('.product__form .product__selectors [data-single-option-selector]').forEach((el) => {
        if (el.type === 'radio' && !el.checked) return;
        option_values[el.getAttribute('data-index')] = el.value;
      });
      const option_values_count = Object.keys(option_values).length;
      const qty_group_label_boxes = document.querySelectorAll(`.product__form .product_qty_group .box`);
      const selector_wrappers = document.querySelectorAll('.selector-wrapper');
      let product_qty_group_selector_index = -1;

      selector_wrappers.forEach((wrapper, index) => {
        if (wrapper.querySelector('.product_qty_group')) {
          product_qty_group_selector_index = index;
        }
      });

      if (option_values_count && qty_group_label_boxes.length) {
        qty_group_label_boxes.forEach((box)=>{
          const box_name = box.querySelector('.box__qty__name__value').innerHTML;
          const box_cart_currency_symbol = box.getAttribute('data-cart-currency-symbol');
          const box_json = JSON.parse(atob(box.getAttribute('data-json')));

          const option1 = product_qty_group_selector_index === 0 ? box_name : option_values['option1'];
          const option2 = product_qty_group_selector_index === 1 ? box_name : option_values['option2'];
          const option3 = product_qty_group_selector_index === 2 ? box_name : option_values['option3'];

          const price_data = getPriceByOption(box_json, option1, option2, option3);
          if (!price_data) return;

          const item_price = `${price_data.price_money} ${box_cart_currency_symbol}`;
          const item_price_pack = `${((price_data.price * parseFloat(box_name)) / 100).toFixed(2).replace('.', ',')} ${box_cart_currency_symbol}`;

          const prices_value = box.querySelector('.box__prices__unit .value');
          const prices_total = box.querySelector('.box__prices__total');
          if (prices_value && prices_total) {
            prices_value.innerHTML = item_price;
            prices_total.innerHTML = item_price_pack;
          }
        });
      }

      setTimeout(()=>{
        const variant_id_el = document.querySelector('[data-tpl^="product"] .product__form [name="id"]');
        const pavailability_value_el = document.querySelector('.pavailability .box__cell--value .value');
        const variant_qty = window.page.product.getInventoryQuantityByVariantId(variant_id_el.value);

        if (variant_qty !== false && variant_qty != null) {
          document.body.setAttribute('data-variant-qty', variant_qty);

          if (variant_id_el && pavailability_value_el) {
            pavailability_value_el.innerHTML = variant_qty; 

            if (option_values_count && qty_group_label_boxes.length) {
              qty_group_label_boxes.forEach((box)=>{

                const box__qty__name__value = box.querySelector('.box__qty__name__value').innerHTML;
                const box_radio_button = box.closest('.radio__button');

                if (box_radio_button) {
                  const box__qty__name__value_number = parseFloat(box__qty__name__value);
                  // console.log('variant_qty is number:', box__qty__name_number);

                  if (box__qty__name__value_number > variant_qty) {
                    box_radio_button.classList.add('disabled_due_to_inventory');
                  } else {
                    box_radio_button.classList.remove('disabled_due_to_inventory');
                  }
                }
              });

              const qty_group = document.querySelector('.product__form .product_qty_group');
              const submit_buttons_wrapper = document.querySelector('.product-single__details .product__submit__buttons');
              const qty_group_unavailable = qty_group ? !qty_group.querySelector('.radio__button:not(.disabled_due_to_inventory)') : false;

              if (qty_group) {
                qty_group.classList.toggle('product_qty_group--unavailable', qty_group_unavailable);
              }

              if (submit_buttons_wrapper) {
                submit_buttons_wrapper.classList.toggle('qty_group_unavailable', qty_group_unavailable);
              }
            };
          }
        }
      }, 100);
    },

    updateProductFormQty: (number) => {
      const qty_input = document.querySelector('.product__form input[name="quantity"]');
      if (qty_input) {
        qty_input.value = parseFloat(number);
      }
    },

    updateQtyVariant: (value) => {
      const qty_options = document.querySelectorAll('.product__form .product_qty_group [type="radio"]');
      let qty_levels = [];
      if (qty_options) {

        qty_options.forEach((option) => {
          const option_name_value = parseFloat(option.closest('.radio__button').querySelector('.box__qty__name__value').innerHTML);
          qty_levels.push(option_name_value);
        });

        const getQtyLevel = (x, qty_levels) => {
          const sorted = [...qty_levels].sort((a, b) => a - b);

          if (x < sorted[0]) return sorted[0];
          for (let i = 0; i < sorted.length; i++) {
            const current = sorted[i];
            const next = sorted[i + 1];

            if (!next || (x >= current && x < next)) {
              return current;
            }
          }
          return sorted[sorted.length - 1];
        };

        const variant_id_el = document.querySelector('[data-tpl^="product"] .product__form [name="id"]');
        const variant_qty = variant_id_el ? window.page.product.getInventoryQuantityByVariantId(variant_id_el.value) : false;
        
        const product_qty_input = document.querySelector('.product-single__wrapper input[name="quantity"]');
        const quantity_input = document.querySelector('.quantity__selector.quantity__input');
        
        if (variant_qty !== false && quantity_input) {
          quantity_input.setAttribute('max', variant_qty);
        }
        
        let corrected_value = parseFloat(value);
        if (variant_qty !== false && corrected_value > variant_qty) {
          corrected_value = variant_qty;
          if (product_qty_input) {
            product_qty_input.value = corrected_value;
          }
          if (quantity_input) {
            quantity_input.value = corrected_value;
          }
        }

        let current_qty_level = getQtyLevel(corrected_value, qty_levels);
        const all_qty_variant_options = document.querySelectorAll('.product__form .product_qty_group .box__qty__name__value');

        all_qty_variant_options.forEach((option) => {
          const option_name_value = parseFloat(option.innerHTML);
          if (option_name_value == current_qty_level) {
            option.closest('.radio__button').querySelector('input[type="radio"]').click();
            
            // Aktualizuj nakład w cdrawer jeśli jest otwarty
            const cdrawer = document.querySelector('#cdrawer');
            if (cdrawer && cdrawer.classList.contains('is-open')) {
              const radioInput = option.closest('.radio__button').querySelector('input[type="radio"]');
              window.main_product_qty_variant = radioInput ? radioInput.value : false;
              window.log('Nakład zmieniony na:', window.main_product_qty_variant);
              
              // Wykonaj ponownie walidację z nowym nakładem
              setTimeout(() => {
                window.cdrawer.validateAvailableCombinations();
                window.cdrawer.updateCdrawerBundleSummary();
              }, 50);
            }
          }
        });

        const plus_button = document.querySelector('.quantity__button--plus');
        if (plus_button && variant_qty !== false) {
          if (corrected_value >= variant_qty) {
            plus_button.classList.add('disabled');
            plus_button.style.pointerEvents = 'none';
            plus_button.style.opacity = '0.5';
          } else {
            plus_button.classList.remove('disabled');
            plus_button.style.pointerEvents = '';
            plus_button.style.opacity = '';
          }
        }

        const data_product_qty_group_max_value = document.querySelector('.product-single__details [data-product-qty-group-max-value]:not([data-product-qty-group-max-value="false"])') ? parseFloat(document.querySelector('.product-single__details [data-product-qty-group-max-value]').getAttribute('data-product-qty-group-max-value')) : false;
        const add_new_bundle_button_wrapper = document.querySelector('.product-single__details .product__submit__buttons');
          
        if (data_product_qty_group_max_value != false && add_new_bundle_button_wrapper) {
          // console.log(`data_product_qty_group_max_value', ${data_product_qty_group_max_value} | product_qty_input.value, ${product_qty_input.value}`);

          if (parseFloat(product_qty_input.value) > data_product_qty_group_max_value) {
            if (add_new_bundle_button_wrapper) {
              add_new_bundle_button_wrapper.classList.add('plus_option_is_selected');
            }
          } else {
            if (add_new_bundle_button_wrapper) {
              add_new_bundle_button_wrapper.classList.remove('plus_option_is_selected');
            }
          }
        }
      }
    }
  }
};

try { window.page.all.init(); } catch (err) { console.error('page.all.init:', err); }
try { window.page.product.init(); } catch (err) { console.error('page.product.init:', err); }


window.cdrawer = {

  init: () => {
    window.cdrawer_customisation_order = 5;
    window.cdrawer_customisations_status = [];

    const main_product_data_e = document.querySelector('#main_product_data');
    if (main_product_data_e) {
      try {
        window.cdrawer_main_product_data = JSON.parse(main_product_data_e.innerHTML);
      } catch (err) {
        console.error('cdrawer: nieprawidłowy JSON w #main_product_data', err);
      }
      main_product_data_e.remove();
    }

    window.cdrawer.addListeners();
    window.cdrawer.updateCdrawerBundleSummary();
  },

  addListeners: () => {
    // console.log('window.cdrawer.addListeners()');
    const add_new_bundle_buttons = document.querySelectorAll('.add_new_bundle:not(.event_is_set)');
    const add_bundle_to_cart_buttons = document.querySelectorAll('#cdrawer .add_bundle_to_cart:not(.event_is_set)');
    const add_new_customisation_button = document.querySelector('#cdrawer .add_new_customisation');
    const close_button = document.querySelector('#cdrawer .cdrawer__close:not(.event_is_set)');
    const drawer_overlay = document.querySelector('.drawer__overlay');

    const ask_product_btn = document.querySelector('.product-single__details .ask_product_btn');
    if (ask_product_btn && !ask_product_btn.classList.contains('event_is_set')) {
      ask_product_btn.addEventListener('click', (e) => {
        const mailto_link = document.querySelector('.product-single__details a[href^="mailto:"]');
        if (mailto_link) {
          window.open(mailto_link.getAttribute('href'), '_blank');
        }
      });
      ask_product_btn.classList.add('event_is_set');
    }
    
    if (add_new_bundle_buttons.length) {
      add_new_bundle_buttons.forEach((button)=> {

        button.addEventListener('click',(e)=>{
          // console.log('Add new bundle button clicked');
          if (e.currentTarget.closest('.product__submit__buttons')?.classList.contains('qty_group_unavailable')) {
            window.page.product.pulseElement(document.querySelector('.product__form .product_qty_group__unavailable'));
            return;
          }

          if (e.currentTarget.closest('.variant--soldout, .variant--unavailabe, .variant--unavailable')) {
            return;
          }

          if (e.currentTarget.closest('.product__submit__buttons')?.classList.contains('qty_below_tier')) {
            window.page.product.pulseElement(document.querySelector('.product__form .product_qty_group'));
            return;
          }

          window.cdrawer_bundle = {};
          const cdrawer_status = document.querySelector('#cdrawer') ? document.querySelector('#cdrawer').getAttribute('data-status') : false;
          const form = e.currentTarget.closest('form');
          const variant_id = form.querySelector('input[name="id"]').value;
          const qty = parseFloat(form.querySelector('input[name="quantity"]').value);
          // opcje mogą być radiami lub hidden inputami (dropdown popout, np. styl swatchy "heygift")
          const radios = Array.from(form.querySelectorAll('[data-single-option-selector]')).filter((el) => el.type !== 'radio' || el.checked);
          const customisation_handle = e.currentTarget.getAttribute('data-customisation-handle');
          const max_customisations = parseFloat(e.currentTarget.getAttribute('data-max-customisations'));
          const plus_option_is_selected = e.currentTarget.closest('.product__submit__buttons') ? e.currentTarget.closest('.product__submit__buttons').classList.contains('plus_option_is_selected') : false;
          
          if (plus_option_is_selected == true) { 
            // console.log('Please contact us to place an order with this custom quantity.');
            
            const mailto_link = document.querySelector('.product-single__details a[href^="mailto:"]');
            if (mailto_link) {
              window.open(mailto_link.getAttribute('href'), '_blank');
            }
          } else {
            let main_product = {
              variant_id: variant_id,
              qty: qty,
              customisation_handle: customisation_handle,
              max_customisations: max_customisations
            };

            radios.forEach((radio) => {
              main_product[radio.getAttribute('data-index')] = {
                name: ((n => n?.match(/\[(.*?)\]/)?.[1] || n || false)(radio.getAttribute('name'))),
                value: radio.value
              }
            });

            window.cdrawer_bundle.main = main_product;

            // console.log('window.cdrawer_bundle', window.cdrawer_bundle);

            if (cdrawer_status == 'init') {
              fetch(`/products/${customisation_handle}?section_id=product`)
                .then(res => res.text())
                .then(html => {
                  const doc = new DOMParser().parseFromString(html, "text/html");
                  const customisation_data = doc.querySelector('#customisation_data');

                  // console.log('customisation_data', customisation_data);

                  if (customisation_data) {
                    window.cdrawer_customisation_data = JSON.parse(customisation_data.innerHTML);
                    window.cdrawer.updateCdrawerHtml(window.cdrawer_customisation_data, true, button);
                  }

                  document.querySelector('#cdrawer').setAttribute('data-status', 'edit');
                  setTimeout(() => {
                    window.cdrawer.open();

                    const cdrawer = document.querySelector('#cdrawer');
                    if (cdrawer && window.cdrawer_customisation_data?.product?.options_metaobject?.group_name_handleized) {
                      cdrawer.setAttribute('data-group-name-handleized', window.cdrawer_customisation_data.product.options_metaobject.group_name_handleized);
                    }

                    window.cdrawer.checkAddNewCustomisation();
                  }, 100);
              })
              .catch((err) => {
                console.error('cdrawer fetch:', err);
                window.cdrawer.open();
              });
            } else {
              window.cdrawer.open();
            }
            
            window.cdrawer.updateCdrawerBundleSummary();
          }
        });

        button.classList.add('event_is_set');
      });
    }

    if (add_bundle_to_cart_buttons.length) {
      add_bundle_to_cart_buttons.forEach((button)=> {
        button.addEventListener('click',() => {
          window.cdrawer.addBundleToCart();
        });

        button.classList.add('event_is_set');
      });
    }

    if (add_new_customisation_button) {
      add_new_customisation_button.addEventListener('click', () => {
        const not_active_customisation = document.querySelector('#cdrawer .customisation:not(.is_active)');

        if (not_active_customisation) {
          window.cdrawer_customisation_order++;
          not_active_customisation.style.order = window.cdrawer_customisation_order;
          not_active_customisation.classList.add('is_active');

          const active_customisations = document.querySelectorAll('#cdrawer .customisation.is_active');

          const cdrawer_body = document.querySelector('#cdrawer .cdrawer__body');
          let scroll_height = 0;

          if (active_customisations.length) {
            active_customisations.forEach((customisation, index) => {
              if (index > 0) {
                scroll_height += customisation.offsetHeight; 
              }
            });
            if (scroll_height > 0) {
              // console.log('scroll_height :',scroll_height);
              cdrawer_body.scrollTo({
                top: scroll_height,
                behavior: 'smooth'
              });
            }
          }
        }

        window.cdrawer.hideAddNewCustomisationButton();
        window.cdrawer.updateCustomisationNumber();

        setTimeout(() => {
          window.cdrawer.setCustomisationStatus();
          window.cdrawer.disableUsedPlaces();
          window.cdrawer.validateAvailableCombinations();
          window.cdrawer.checkAddNewCustomisation();
        }, 350);
      });
    }

    if (close_button) {
      close_button.addEventListener('click',() => {
        window.cdrawer.close();
      });
      close_button.classList.add('event_is_set');
    }

    if (drawer_overlay) {
      drawer_overlay.addEventListener('click',() => {
        window.cdrawer.close();
      });
      drawer_overlay.classList.add('event_is_set');
    }
  },

  updateCdrawerHtml: (data, open_cdrawer, button) => {
    const getOptionsArrayWithHandles = (productData) => {
      const temp = {
        option1: {},
        option2: {},
        option3: {}
      };

      const variantCombinations = productData.variants.map(variant => ({
        id: variant.id,
        combination: [variant.option1, variant.option2, variant.option3]
      }));

      productData.variants.forEach(variant => {
        ['option1', 'option2', 'option3'].forEach(optionKey => {
          const value = variant[optionKey];
          if (!value) return;

          if (!temp[optionKey][value]) {
            temp[optionKey][value] = {
              ids: [],
              combinations: []
            };
          }

          temp[optionKey][value].ids.push(variant.id);
          temp[optionKey][value].combinations.push([
            variant.option1,
            variant.option2,
            variant.option3
          ]);
        });
      });

      const result = ['option1', 'option2', 'option3'].map((optionKey, index) => ({
        key: optionKey,
        name: productData.options[index],
        name_handleized: productData.options_handleized[index],
        values: Object.entries(temp[optionKey]).map(([valueName, data]) => ({
          name: valueName,
          ids: data.ids,
          combinations: data.combinations
        }))
      }));

      return result;
    };

    // console.log('data', data);

    const available_options = getOptionsArrayWithHandles(data.product);
    const filtered_options = available_options.filter(opt => 
      opt.name !== undefined && opt.name_handleized !== undefined
    );

    // console.log('available_options', available_options)

    filtered_options.forEach((available_option, index) => {

      if (data.product.option_translations.place.some(keyword => available_option.name_handleized.includes(keyword))) {
        
        const box_options = document.querySelectorAll('#cdrawer .customisation__options .box--place .box__options');
        
        box_options.forEach((single_box_options)=> {
          let html = '';
          available_option.values.forEach((item, single_option_index) => {
            let single_option_image = data.product.options_metaobject[`option${index+1}`].images[single_option_index];
            if (single_option_image) {
              html += `<div class="box__option" data-ids="${JSON.stringify(item.ids)}" data-combinations="${JSON.stringify(item.combinations).replace(/"/g, "'")}"><div class="box__option__image"><img src="${single_option_image.replace(/&amp;/g, '&')}" alt="${item.name}"></div><div class="box__option__name">${item.name}</div></div>`;
            } else {
              html += `<div class="box__option" data-ids="${JSON.stringify(item.ids)}" data-combinations="${JSON.stringify(item.combinations).replace(/"/g, "'")}">${item.name}</div>`;
            }
          });
          single_box_options.innerHTML = html;

          let additional_file = data.product.options_metaobject[`option${index+1}`].additional_file;
          let additional_file_type_t = data.product.options_metaobject[`option${index+1}`].additional_file_type_t;
          if (additional_file) {
            single_box_options.closest('.box').insertAdjacentHTML('beforeend', `<a href="${additional_file}" download class="box__download"><div class="box__download__text">${additional_file_type_t}</div><div class="box__download__icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2.75006V15.8126" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.8125 9.62506L11 15.8126L17.1875 9.62506" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.4375 18.5626H18.5625" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div></a>`);
          }
        });
        
        const current_options_box = box_options[0]?.closest('.box');
        const info_enabled = data.product.options_metaobject[`option${index+1}`].info_enabled;
        const info_icon = data.product.options_metaobject[`option${index+1}`].info_icon;
        const info_title = data.product.options_metaobject[`option${index+1}`].info_title;
        const info_content = data.product.options_metaobject[`option${index+1}`].info_content;
        
        if (current_options_box && info_enabled != false && info_icon != false && info_title != false && info_content != false) {
          if (info_icon == 'question') {
            current_options_box.querySelector('.info').innerHTML = `<span class="info__icon" data-action-open-cmodal="cdrawer_option${index+1}_info"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 16.5001C11.5695 16.5001 12.0312 16.0384 12.0312 15.4688C12.0312 14.8993 11.5695 14.4376 11 14.4376C10.4305 14.4376 9.96875 14.8993 9.96875 15.4688C9.96875 16.0384 10.4305 16.5001 11 16.5001Z" fill="black"/><path d="M11 12.3751V11.6876C12.5185 11.6876 13.75 10.6099 13.75 9.28131C13.75 7.95272 12.5185 6.87506 11 6.87506C9.48148 6.87506 8.25 7.95272 8.25 9.28131V9.62506" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 19.2501C15.5563 19.2501 19.25 15.5564 19.25 11.0001C19.25 6.44371 15.5563 2.75006 11 2.75006C6.44365 2.75006 2.75 6.44371 2.75 11.0001C2.75 15.5564 6.44365 19.2501 11 19.2501Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;
          } else if (info_icon == 'info') {
            current_options_box.querySelector('.info').innerHTML = `<span class="info__icon" data-action-open-cmodal="cdrawer_option${index+1}_info"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.3125 10.3125C10.4948 10.3125 10.6697 10.3849 10.7986 10.5139C10.9276 10.6428 11 10.8177 11 11V14.4375C11 14.6198 11.0724 14.7947 11.2014 14.9236C11.3303 15.0526 11.5052 15.125 11.6875 15.125" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.6562 8.25C11.2258 8.25 11.6875 7.78829 11.6875 7.21875C11.6875 6.64921 11.2258 6.1875 10.6562 6.1875C10.0867 6.1875 9.625 6.64921 9.625 7.21875C9.625 7.78829 10.0867 8.25 10.6562 8.25Z" fill="black"/></svg></span>`;
          }
        }

      } else if (data.product.option_translations.color.some(keyword => available_option.name_handleized.includes(keyword))) {

        const box_options = document.querySelectorAll('#cdrawer .customisation__options .box--color .box__options');
        
        box_options.forEach((single_box_options)=> {
          let html = '';
          available_option.values.forEach((item, single_option_index) => {
            let value_number = Number.isInteger(parseInt(String(item?.name ?? '').replace(/\D/g, ''), 10)) ? parseInt(String(item.name).replace(/\D/g, ''), 10) : false;
            let divs = '<div></div>'.repeat(value_number);
            html += `<div class="box__option" data-colors-number="${value_number}" data-ids="${JSON.stringify(item.ids)}" data-combinations="${JSON.stringify(item.combinations).replace(/"/g, "'")}"><div class="box__option__colors">${divs}</div><div class="box__option__name">${item.name}</div></div>`;
          });
          single_box_options.innerHTML = html;

          let additional_file = data.product.options_metaobject[`option${index+1}`].additional_file;
          let additional_file_type_t = data.product.options_metaobject[`option${index+1}`].additional_file_type_t;
          if (additional_file) {
            single_box_options.closest('.box').insertAdjacentHTML('beforeend', `<a href="${additional_file}" download class="box__download"><div class="box__download__text">${additional_file_type_t}</div><div class="box__download__icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2.75006V15.8126" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.8125 9.62506L11 15.8126L17.1875 9.62506" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.4375 18.5626H18.5625" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div></a>`);
          }
        });
        
        const current_options_box = box_options[0]?.closest('.box');
        const info_enabled = data.product.options_metaobject[`option${index+1}`].info_enabled;
        const info_icon = data.product.options_metaobject[`option${index+1}`].info_icon;
        const info_title = data.product.options_metaobject[`option${index+1}`].info_title;
        const info_content = data.product.options_metaobject[`option${index+1}`].info_content;
        
        if (current_options_box && info_enabled != false && info_icon != false && info_title != false && info_content != false) {
          if (info_icon == 'question') {
            current_options_box.querySelector('.info').innerHTML = `<span class="info__icon" data-action-open-cmodal="cdrawer_option${index+1}_info"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 16.5001C11.5695 16.5001 12.0312 16.0384 12.0312 15.4688C12.0312 14.8993 11.5695 14.4376 11 14.4376C10.4305 14.4376 9.96875 14.8993 9.96875 15.4688C9.96875 16.0384 10.4305 16.5001 11 16.5001Z" fill="black"/><path d="M11 12.3751V11.6876C12.5185 11.6876 13.75 10.6099 13.75 9.28131C13.75 7.95272 12.5185 6.87506 11 6.87506C9.48148 6.87506 8.25 7.95272 8.25 9.28131V9.62506" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 19.2501C15.5563 19.2501 19.25 15.5564 19.25 11.0001C19.25 6.44371 15.5563 2.75006 11 2.75006C6.44365 2.75006 2.75 6.44371 2.75 11.0001C2.75 15.5564 6.44365 19.2501 11 19.2501Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;
          } else if (info_icon == 'info') {
            current_options_box.querySelector('.info').innerHTML = `<span class="info__icon" data-action-open-cmodal="cdrawer_option${index+1}_info"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.3125 10.3125C10.4948 10.3125 10.6697 10.3849 10.7986 10.5139C10.9276 10.6428 11 10.8177 11 11V14.4375C11 14.6198 11.0724 14.7947 11.2014 14.9236C11.3303 15.0526 11.5052 15.125 11.6875 15.125" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.6562 8.25C11.2258 8.25 11.6875 7.78829 11.6875 7.21875C11.6875 6.64921 11.2258 6.1875 10.6562 6.1875C10.0867 6.1875 9.625 6.64921 9.625 7.21875C9.625 7.78829 10.0867 8.25 10.6562 8.25Z" fill="black"/></svg></span>`;
          }
        }
        
      } else if (data.product.option_translations.type.some(keyword => available_option.name_handleized.includes(keyword))) {

        const box_options = document.querySelectorAll('#cdrawer .customisation__options .box--type .box__options');

        box_options.forEach((single_box_options)=> {
          let html = '';
          available_option.values.forEach((item, single_option_index) => {
            let single_option_image = data.product.options_metaobject[`option${index+1}`].images[single_option_index];
            if (single_option_image) {
              html += `<div class="box__option" data-ids="${JSON.stringify(item.ids)}" data-combinations="${JSON.stringify(item.combinations).replace(/"/g, "'")}"><div class="box__option__image"><img src="${single_option_image.replace(/&amp;/g, '&')}" alt="${item.name}"></div><div class="box__option__name">${item.name}</div></div>`;
            } else {
              html += `<div class="box__option" data-ids="${JSON.stringify(item.ids)}" data-combinations="${JSON.stringify(item.combinations).replace(/"/g, "'")}">${item.name}</div>`;
            }
          });
          single_box_options.innerHTML = html;

          let additional_file = data.product.options_metaobject[`option${index+1}`].additional_file;
          let additional_file_type_t = data.product.options_metaobject[`option${index+1}`].additional_file_type_t;
          if (additional_file) {
            single_box_options.closest('.box').insertAdjacentHTML('beforeend', `<a href="${additional_file}" download class="box__download"><div class="box__download__text">${additional_file_type_t}</div><div class="box__download__icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2.75006V15.8126" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.8125 9.62506L11 15.8126L17.1875 9.62506" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.4375 18.5626H18.5625" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div></a>`);
          }
        });
        
        const current_options_box = box_options[0]?.closest('.box');
        const info_enabled = data.product.options_metaobject[`option${index+1}`].info_enabled;
        const info_icon = data.product.options_metaobject[`option${index+1}`].info_icon;
        const info_title = data.product.options_metaobject[`option${index+1}`].info_title;
        const info_content = data.product.options_metaobject[`option${index+1}`].info_content;
        
        if (current_options_box && info_enabled != false && info_icon != false && info_title != false && info_content != false) {
          if (info_icon == 'question') {
            current_options_box.querySelector('.info').innerHTML = `<span class="info__icon" data-action-open-cmodal="cdrawer_option${index+1}_info"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 16.5001C11.5695 16.5001 12.0312 16.0384 12.0312 15.4688C12.0312 14.8993 11.5695 14.4376 11 14.4376C10.4305 14.4376 9.96875 14.8993 9.96875 15.4688C9.96875 16.0384 10.4305 16.5001 11 16.5001Z" fill="black"/><path d="M11 12.3751V11.6876C12.5185 11.6876 13.75 10.6099 13.75 9.28131C13.75 7.95272 12.5185 6.87506 11 6.87506C9.48148 6.87506 8.25 7.95272 8.25 9.28131V9.62506" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 19.2501C15.5563 19.2501 19.25 15.5564 19.25 11.0001C19.25 6.44371 15.5563 2.75006 11 2.75006C6.44365 2.75006 2.75 6.44371 2.75 11.0001C2.75 15.5564 6.44365 19.2501 11 19.2501Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;
          } else if (info_icon == 'info') {
            current_options_box.querySelector('.info').innerHTML = `<span class="info__icon" data-action-open-cmodal="cdrawer_option${index+1}_info"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.3125 10.3125C10.4948 10.3125 10.6697 10.3849 10.7986 10.5139C10.9276 10.6428 11 10.8177 11 11V14.4375C11 14.6198 11.0724 14.7947 11.2014 14.9236C11.3303 15.0526 11.5052 15.125 11.6875 15.125" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.6562 8.25C11.2258 8.25 11.6875 7.78829 11.6875 7.21875C11.6875 6.64921 11.2258 6.1875 10.6562 6.1875C10.0867 6.1875 9.625 6.64921 9.625 7.21875C9.625 7.78829 10.0867 8.25 10.6562 8.25Z" fill="black"/></svg></span>`;
          }
        }
        
      }
    });

    const customisations_box_file = document.querySelectorAll('#cdrawer .box--file');
    
    if (customisations_box_file.length) {
      const additional_file = data.product.options_metaobject.file.additional_file;
      const additional_file_type_t = data.product.options_metaobject.file.additional_file_type_t;

      if (additional_file) {
        customisations_box_file.forEach((item) => {
          item.querySelector('.box__content').insertAdjacentHTML('beforebegin', `<a href="${additional_file}" download class="box__download"><div class="box__download__text">${additional_file_type_t}</div><div class="box__download__icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2.75006V15.8126" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.8125 9.62506L11 15.8126L17.1875 9.62506" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.4375 18.5626H18.5625" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div></a>`);
        });
      }

      const info_enabled = data.product.options_metaobject.file.info_enabled;
      const info_icon = data.product.options_metaobject.file.info_icon;
      const info_title = data.product.options_metaobject.file.info_title;
      const info_content = data.product.options_metaobject.file.info_content;
      
      if (info_enabled != false && info_icon != false && info_title != false && info_content != false) {
        if (info_icon == 'question') {
          customisations_box_file[0].querySelector('.info').innerHTML = `<span class="info__icon" data-action-open-cmodal="cdrawer_file_info"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 16.5001C11.5695 16.5001 12.0312 16.0384 12.0312 15.4688C12.0312 14.8993 11.5695 14.4376 11 14.4376C10.4305 14.4376 9.96875 14.8993 9.96875 15.4688C9.96875 16.0384 10.4305 16.5001 11 16.5001Z" fill="black"/><path d="M11 12.3751V11.6876C12.5185 11.6876 13.75 10.6099 13.75 9.28131C13.75 7.95272 12.5185 6.87506 11 6.87506C9.48148 6.87506 8.25 7.95272 8.25 9.28131V9.62506" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 19.2501C15.5563 19.2501 19.25 15.5564 19.25 11.0001C19.25 6.44371 15.5563 2.75006 11 2.75006C6.44365 2.75006 2.75 6.44371 2.75 11.0001C2.75 15.5564 6.44365 19.2501 11 19.2501Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;
        } else if (info_icon == 'info') {
          customisations_box_file[0].querySelector('.info').innerHTML = `<span class="info__icon" data-action-open-cmodal="cdrawer_file_info"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.3125 10.3125C10.4948 10.3125 10.6697 10.3849 10.7986 10.5139C10.9276 10.6428 11 10.8177 11 11V14.4375C11 14.6198 11.0724 14.7947 11.2014 14.9236C11.3303 15.0526 11.5052 15.125 11.6875 15.125" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.6562 8.25C11.2258 8.25 11.6875 7.78829 11.6875 7.21875C11.6875 6.64921 11.2258 6.1875 10.6562 6.1875C10.0867 6.1875 9.625 6.64921 9.625 7.21875C9.625 7.78829 10.0867 8.25 10.6562 8.25Z" fill="black"/></svg></span>`;
        }
      }

    }

    const customisations = document.querySelectorAll('#cdrawer .customisation');
    if (customisations.length) {
      customisations.forEach((customisation, index) => {
        if (index >= window.cdrawer_bundle.main.max_customisations) {
          customisation.remove();
        }
      });
    }

    const customisations_remove_buttons = document.querySelectorAll('#cdrawer .customisation__remove');
    if (customisations_remove_buttons) {
      customisations_remove_buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const customisation = e.currentTarget.closest('.customisation');
          if (!customisation) return;
          
          const id = customisation.getAttribute('data-id');
          window.cdrawer.removeCustomisation(id);
        });
      });
    }
    
    setTimeout(()=> {
      window.cdrawer.updateCdrawerActions();
      window.cdrawer.disableUsedPlaces();
      window.cdrawer.validateAvailableCombinations();
      window.page.all.addListeners();
    }, 50);

    setTimeout(()=> {
      if (open_cdrawer == true) {
        window.cdrawer.open();
      }
    }, 100);
  },

  reset: () => {
    const cdrawer = document.querySelector('#cdrawer');
    const cdrawer_body = document.querySelector('#cdrawer .cdrawer__body');

    cdrawer.setAttribute('data-status', 'edit');

    ['1', '2', '3', '4', '5'].forEach(key => {
      delete window.cdrawer_bundle[key];
    });

    const customisations = document.querySelectorAll('#cdrawer .customisation');
    
    if (customisations.length) {
      customisations.forEach((customisation, index) => {
        const id = customisation.getAttribute('data-id');
        window.cdrawer.resetCustomisation(id);
        customisation.style.removeProperty('order');
        if (index === 0) {
          customisation.classList.add('is_active');
        } else {
          customisation.classList.remove('is_active');
        }
      }); 
    }

    cdrawer_body.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    window.cdrawer.updateCdrawerBundle();
  },

  searchMainProductVariantPrice: (variant_id) => {
    const idToFind = parseFloat(variant_id);
    const variant = window.cdrawer_main_product_data.product.variants.find(v => parseFloat(v.id) === idToFind);
    return variant ? parseFloat(variant.price) : false;
  },

  searchProductVariantPrice: (variant_id) => {
    const idToFind = parseFloat(variant_id);
    const variant = window.cdrawer_customisation_data.product.variants.find(v => parseFloat(v.id) === idToFind);
    return variant ? parseFloat(variant.price) : false;
  },

  updateCdrawerBundleSummary: () => {
    const input_variant = document.querySelector('.product-single__details .product__form [name="id"]');
    const input_qty = document.querySelector('.product-single__details .product__form [name="quantity"]');
    const summary = document.querySelector('#cdrawer .bundle_summary');
    
    if (summary && input_variant && input_qty && window.cdrawer_bundle) {
      const main_product_price_cents = window.cdrawer.searchMainProductVariantPrice(input_variant.value);
      const main_product_price = main_product_price_cents/100;
      const main_product_qty = parseFloat(input_qty.value);

      summary.querySelector('.box--qty--product .box__qty .value').innerHTML = main_product_qty;
      summary.querySelector('.box--qty--product .box__price .value').innerHTML = String(main_product_price).replace('.', ',');
      summary.querySelector('.box--qty--product .box__price .currency').innerHTML = window.cdrawer_main_product_data.shop.currency_symbol;

      let customisations_total_price_per_item = 0;
      let customisations_total_price_per_item_cents = 0;
      
      Object.entries(window.cdrawer_bundle).forEach(([key, value]) => {
        if (key != 'main') {
          customisations_total_price_per_item_cents += value.price;
        }
      });

      if (customisations_total_price_per_item_cents > 0) {
        customisations_total_price_per_item = customisations_total_price_per_item_cents/100;
      }

      const total_without_tax_cents = (main_product_qty * main_product_price_cents) + (main_product_qty * customisations_total_price_per_item_cents);
      const total_without_tax = total_without_tax_cents/100;

      const total_with_tax_cents = total_without_tax_cents * (1 + window.cdrawer_main_product_data.shop.current_market_tax / 100);
      const total_with_tax = total_with_tax_cents/100;

      summary.querySelector('.box--qty--customisations .box__qty .value').innerHTML = main_product_qty;
      summary.querySelector('.box--qty--customisations .box__price .value').innerHTML = String(customisations_total_price_per_item.toFixed(2)).replace('.', ',');
      summary.querySelector('.box--qty--customisations .box__price .currency').innerHTML = window.cdrawer_main_product_data.shop.currency_symbol;

      summary.querySelector('.box--total_without_tax .box__price .value').innerHTML = String(total_without_tax.toFixed(2)).replace('.', ',');
      summary.querySelector('.box--total_without_tax .box__price .currency').innerHTML = window.cdrawer_main_product_data.shop.currency_symbol;

      summary.querySelector('.box--total_with_tax .box__price .value').innerHTML = String(total_with_tax.toFixed(2)).replace('.', ',');
      summary.querySelector('.box--total_with_tax .box__price .currency').innerHTML = window.cdrawer_main_product_data.shop.currency_symbol;
    }

    // console.log(window.cdrawer_customisation_data);
  },

  addBundleToCart: () => {
    // console.log('window.cdrawer.addBundleToCart()');

    window.cdrawer.setCdrawerStatus('adding_to_cart');

    if (window.cdrawer_bundle) {
      let items = [];
      const timestamp = Date.now();

      Object.entries(window.cdrawer_bundle).forEach(([key, value]) => {
        if (key == 'main') {
          let product = {
            id: String(value.variant_id),
            quantity: parseFloat(value.qty),
            properties: {
              _customized_product_id: `${value.variant_id}_${timestamp}`
            }
          };
          product.properties[window.cdrawer_customisation_data.line_item_keys.bundle] = `${timestamp}`;
          items.push(product);
        } else {
          let product = {
            id: String(value.variant_id),
            quantity: parseFloat(window.cdrawer_bundle.main.qty),
            properties: {
              _customized_product_id: `${window.cdrawer_bundle.main.variant_id}_${timestamp}`,
              _customisation_id: `${key}`
            }
          };
          product.properties[window.cdrawer_customisation_data.line_item_keys.bundle] = `${timestamp}`;
          items.push(product);
        }
      });

      items.reverse();
      // console.log('items', items);

      const formData = new FormData();

      items.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity);
      
        Object.entries(item.properties).forEach(([key, value]) => {
          formData.append(`items[${index}][properties][${key}]`, value);
        });

        if (item.properties._customisation_id) {
          const input = document.querySelector(`.cdrawer [name="customisation_${item.properties._customisation_id}_file"]`);
          if (input && input.files.length) {
            formData.append(`items[${index}][properties][${window.cdrawer_customisation_data.translations.file}]`, input.files[0]);
          }
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(res => res.json())
      .then(data => {
        // console.log(data)
        window.cdrawer.setCdrawerStatus('added_to_cart');
        window.ccart.reload();

        setTimeout(() => {
          window.cdrawer.close();
          
          const cartDrawer = document.querySelector('#cart-drawer');
          document.body.classList.add('js-drawer-open-cart');
          if (cartDrawer) {
            cartDrawer.classList.add('is-open');
          }
        }, 2000);

        setTimeout(() => {
          const cdrawer_body = document.querySelector('#cdrawer .cdrawer__body');
          cdrawer_body.scrollTo({
            top: 0,
            behavior: 'smooth'
          });

          window.cdrawer.reset();
          window.cdrawer.setCdrawerStatus('edit');
        }, 2500);
      });
    }
  },

  checkVariantExistInCdrawerBundle: (id) => {
    let exist = false;
    Object.entries(window.cdrawer_bundle).forEach(([key, value]) => {
      if (String(value.variant_id) == String(id)) {
        exist = true;
      }
    });

    return exist;
  },

  checkAddNewCustomisation: (additional_action) => {
    // console.log('window.cdrawer.checkAddNewCustomisation()');
    setTimeout(() => {
      const is_active_customisations = document.querySelectorAll('#cdrawer .customisation.is_active');
      const is_set_customisations = document.querySelectorAll('#cdrawer .customisation.is_set');
      let show_button = false;
      let show_info = false;
      
      const max_customisations = window.cdrawer_bundle.main.max_customisations;
      const reached_max = is_active_customisations.length >= max_customisations;
      const all_active_are_set = is_active_customisations.length == is_set_customisations.length;
      const has_unset_active = is_active_customisations.length > is_set_customisations.length;
      
      // console.log('checkAddNewCustomisation DEBUG:', {
      //   active_count: is_active_customisations.length,
      //   set_count: is_set_customisations.length,
      //   max_customisations: max_customisations,
      //   reached_max: reached_max,
      //   all_active_are_set: all_active_are_set,
      //   has_unset_active: has_unset_active
      // });
      
      if (!reached_max && all_active_are_set) {
        show_button = true;
        // console.log('Showing button');
      } else if (!reached_max && has_unset_active && max_customisations > 1) {
        show_info = true;
        // console.log('Showing info');
      }

      if (show_button == true) {
        window.cdrawer.showAddNewCustomisationButton();
        window.cdrawer.hideAddNewCustomisationInfo();
      } else {
        window.cdrawer.hideAddNewCustomisationButton();
        
        if (show_info == true) {
          window.cdrawer.showAddNewCustomisationInfo();
        } else {
          window.cdrawer.hideAddNewCustomisationInfo();
        }
      }

      const cdrawer_body = document.querySelector('#cdrawer .cdrawer__body');

      if (additional_action == 'scroll_to_end') {
        cdrawer_body.scrollTo({
          top: cdrawer_body.scrollHeight,
          behavior: 'smooth'
        });
      } else if (additional_action == 'scroll_to_last_active') {
        let scroll_height = 0;
        const all_active_customisations = document.querySelectorAll('#cdrawer .customisation.is_active');

        if (all_active_customisations.length > 1) {
          all_active_customisations.forEach((customisation, index) => {
            if (index > 0) {
              scroll_height += customisation.offsetHeight;
            }
          });
        }

        cdrawer_body.scrollTo({
          top: scroll_height,
          behavior: 'smooth'
        });
      }
    }, 300);
  },

  showAddNewCustomisationButton: () => {
    document.querySelector('#cdrawer').classList.add('show_add_new_customisation');
  },

  hideAddNewCustomisationButton: () => {
    document.querySelector('#cdrawer').classList.remove('show_add_new_customisation');
  },

  showAddNewCustomisationInfo: () => {
    document.querySelector('#cdrawer').classList.add('show_add_new_customisation_info');
  },

  hideAddNewCustomisationInfo: () => {
    document.querySelector('#cdrawer').classList.remove('show_add_new_customisation_info');
  },

  showSummary: () => {
    document.querySelector('#cdrawer').classList.add('show_summary');
  },

  hideSummary: () => {
    document.querySelector('#cdrawer').classList.remove('show_summary');
  },

  setCustomisationStatus: () => {
    // console.log('window.cdrawer.setCustomisationStatus()')
    const customisations = document.querySelectorAll('#cdrawer .customisation');
    if (customisations.length) {
      customisations.forEach((customisation, index) => {

        const customisation_is_active = customisation.classList.contains('is_active');
        const input_variant = customisation.querySelector('input[name*="_variant_id"]');
        const input_file = customisation.querySelector('input[name*="_file"]');
        let customisation_is_set = false;

        if (input_variant.value != '' && input_file?.files?.length > 0) {
          customisation_is_set = true;
        }

        window.cdrawer_customisations_status[index] = customisation_is_set == true ? 1 : (customisation_is_active ? 0 : -1) ;
      });
    }
    // console.log('window.cdrawer_customisations_status : ',window.cdrawer_customisations_status);

    const draft_customisation_exist = cdrawer_customisations_status.includes(0);
    const active_customisation_exist = cdrawer_customisations_status.includes(1);

    if (draft_customisation_exist == true) {
      window.cdrawer.blockAddToCartButton();
    } else {
      if (active_customisation_exist == true) {
        window.cdrawer.unblockAddToCartButton();
      }
    };
  },

  blockAddToCartButton: () => {
    // console.log('window.cdrawer.blockAddToCartButton()');
    const button = document.querySelector('#cdrawer .add_bundle_to_cart');
    if (button) {
      button.classList.add('is_disabled');
    }
  },

  unblockAddToCartButton: () => {
    // console.log('window.cdrawer.unblockAddToCartButton()');
    const button = document.querySelector('#cdrawer .add_bundle_to_cart');
    if (button) {
      button.classList.remove('is_disabled');
    }
  },

  checkAllCustomisations: (box_option_customisation_id) => {
    // console.log('window.cdrawer.checkAllCustomisations()');
    
    let customisations_is_set = [];
    const customisations = document.querySelectorAll('#cdrawer .customisation');
    
    if (customisations.length) {
      customisations.forEach((customisation, index) => {
        const customisation_is_active = customisation.classList.contains('is_active');
        const customisation_id = customisation.getAttribute('data-id');
        const input_variant = customisation.querySelector('input[name*="_variant_id"]');
        const input_file = customisation.querySelector('input[name*="_file"]');
        let customisation_is_set = false;

        if (box_option_customisation_id) {
          window.cdrawer.checkCombinationForCustomisation(box_option_customisation_id);
        } else {
          window.cdrawer.checkCombinationForCustomisation(customisation_id);
        }

        if (input_variant.value != '' && input_file?.files?.length > 0) {
          customisation_is_set = true;
        }

        window.cdrawer.setCustomisationStatus();

        if (customisation_is_set == true) {
          customisation.classList.add('is_set');
          customisations_is_set.push(true);
        } else {
          customisation.classList.remove('is_set');
          customisations_is_set.push(false);
        }
      }); 
    }

    // console.log('customisations_is_set', customisations_is_set);
    window.cdrawer.checkAddNewCustomisation();
  },

  setCdrawerStatus: (status) => {
    // console.log(`window.cdrawer.setCdrawerStatus(${status})`);
    const cdrawer = document.querySelector('#cdrawer');
    cdrawer.setAttribute('data-status', status);
  },

  setVariantIdForCustomisation: (id, new_value) => {
    const input = document.querySelector(`.customisation[data-id="${id}"]`);
    if (input) {
      input.value = new_value;
      input.closest('.customisation').classList.add('is_set');
    }

    window.cdrawer.updateCdrawerBundle();
  },
  
  resetVariantIdForCustomisation: (id) => {
    const input = document.querySelector(`.customisation[data-id="${id}"]`);
    if (input) {
      input.value = '';
      input.closest('.customisation').classList.remove('is_set');
    }

    window.cdrawer.updateCdrawerBundle();
  },

  resetCustomisation: (id) => {
    const customisation = document.querySelector(`.customisation[data-id="${id}"]`);
    if (!customisation) return;

    const container = customisation.querySelector('.customisation__options');

    container.querySelectorAll('.box__option').forEach(opt => {
      opt.classList.remove('is_checked', 'is_disabled');
      opt.classList.add('is_active');
    });

    container.querySelectorAll('.box').forEach(box => {
      if (!box.classList.contains('box--file')) {
        box.style.display = '';
      }
    });

    const variantInput = container.querySelector('input[name*="variant_id"]');
    if (variantInput) {
      variantInput.value = '';
    }

    const fileBox = container.querySelector('.box--file');
    if (fileBox) {
      const fileInput = fileBox.querySelector('input[type="file"]');
      const dropzone = fileBox.querySelector('.box__content__dropzone');

      if (fileInput) {
        fileInput.value = '';
      }

      if (dropzone) {
        dropzone.textContent = dropzone.getAttribute('data-default-text') || '{{ "customisations.options.file.dropzone" | t }}';
      }
    }

    window.cdrawer.updateCdrawerBundle();
    customisation.classList.remove('is_set');
    customisation.classList.remove('show_reset');
    window.cdrawer.validateAvailableCombinations();
    window.cdrawer.checkAddNewCustomisation();
  },

  updateShowResetButton: (customisationId) => {
    const customisation = document.querySelector(`.customisation[data-id="${customisationId}"]`);
    if (!customisation) return;

    const container = customisation.querySelector('.customisation__options');
    const hasAnyOptionChecked = container.querySelector('.box__option.is_checked:not(.box__option--empty)') !== null;
    const fileInput = container.querySelector('input[type="file"]');
    const hasFile = fileInput && fileInput.files && fileInput.files.length > 0;
    
    if (hasAnyOptionChecked || hasFile) {
      customisation.classList.add('show_reset');
    } else {
      customisation.classList.remove('show_reset');
    }
  },

  removeCustomisation: (id) => {
    const customisation = document.querySelector(`.customisation[data-id="${id}"]`);
    if (!customisation) return;

    const container = customisation.querySelector('.customisation__options');

    container.querySelectorAll('.box__option').forEach(opt => {
      opt.classList.remove('is_checked', 'is_disabled');
      opt.classList.add('is_active');
    });

    container.querySelectorAll('.box').forEach(box => {
      if (!box.classList.contains('box--file')) {
        box.style.display = '';
      }
    });

    const variantInput = container.querySelector('input[name*="variant_id"]');
    if (variantInput) {
      variantInput.value = '';
    }

    const fileBox = container.querySelector('.box--file');
    if (fileBox) {
      const fileInput = fileBox.querySelector('input[type="file"]');
      const dropzone = fileBox.querySelector('.box__content__dropzone');

      if (fileInput) {
        fileInput.value = '';
      }

      if (dropzone) {
        dropzone.textContent = dropzone.getAttribute('data-default-text') || '{{ "customisations.options.file.dropzone" | t }}';
      }
    }

    window.cdrawer.updateCdrawerBundle();
    customisation.classList.remove('is_active', 'is_open', 'is_set', 'show_reset');
    window.cdrawer.checkAddNewCustomisation('scroll_to_last_active');
    window.cdrawer.updateCustomisationNumber();
    window.cdrawer.disableUsedPlaces();
    window.cdrawer.validateAvailableCombinations();
  },

  updateCustomisationNumber: () => {
    // console.log('window.cdrawer.updateCustomisationNumber()');
    const customisations = Array.from(document.querySelectorAll('#cdrawer .customisation.is_active'));
    customisations
      .sort((a, b) => parseInt(a.style.order) - parseInt(b.style.order))
      .forEach((item, index) => {
        const span = item.querySelector('.customisation__title span');
        if (span) {
          span.textContent = `(${index + 1})`;
        }
      });
  },

  checkCombinationForCustomisation: (id) => {
    const customisation = document.querySelector(`.customisation[data-id="${id}"]`);
    if (!customisation) return false;

    const container = customisation.querySelector('.customisation__options');
    const allGroups = [...container.querySelectorAll('.box__options')];

    const selected = allGroups.map(group => {
      const checked = group.querySelector('.box__option.is_checked:not(.box__option--empty)');
      return checked ? checked.textContent.trim() : null;
    });

    // Jeśli nie wszystkie opcje są wybrane, nie waliduj jeszcze (zwróć true aby nie blokować)
    if (selected.length !== allGroups.length || !selected.every(Boolean)) return true;

    const selectedWithQty = window.main_product_qty_variant 
      ? [...selected, window.main_product_qty_variant.toString()]
      : selected;

    const isValid = [...container.querySelectorAll('.box__option.is_checked:not(.box__option--empty)')].some(opt => {
      const combinations = JSON.parse(opt.dataset.combinations.replace(/'/g, '"'));
      return combinations.some(combo => combo.every((val, i) => val === selectedWithQty[i]));
    });

    if (!isValid) {
      // alert(`Niedozwolona kombinacja (${id})`);
      alert(`Niedozwolona kombinacja`);
      return false;
    }

    let variantId = null;

    outerLoop:
    for (const opt of container.querySelectorAll('.box__option:not(.box__option--empty)')) {
      const combinations = JSON.parse(opt.dataset.combinations.replace(/'/g, '"'));
      const ids = JSON.parse(opt.dataset.ids || '[]');

      for (let i = 0; i < combinations.length; i++) {
        const combo = combinations[i];
        if (combo.length === selectedWithQty.length && combo.every((val, index) => val === selectedWithQty[index])) {
          variantId = ids[i] || null;
          break outerLoop;
        }
      }
    }

    const variantInput = container.querySelector('input[name*="variant_id"]');
    if (variantInput) {
      variantInput.value = variantId || '';
    }
  },

  validateAvailableCombinations: (customisationId) => {
    window.log('=== validateAvailableCombinations START ===', customisationId);
    window.log('Nakład z głównego produktu:', window.main_product_qty_variant);
    
    const customisations = document.querySelectorAll('#cdrawer .customisation.is_active');
    if (!customisations.length) {
      window.log('Brak aktywnych customizacji');
      return;
    }

    // Zbierz wszystkie używane kombinacje przez INNE customizacje
    const usedCombinations = [];
    customisations.forEach(customisation => {
      const otherCustomisationId = customisation.getAttribute('data-id');
      
      // Pomijamy customizację, którą aktualnie edytujemy
      if (customisationId && otherCustomisationId === customisationId) return;
      
      const container = customisation.querySelector('.customisation__options');
      if (!container) return;
      
      const allGroups = [...container.querySelectorAll('.box__options')];
      const selected = allGroups.map(group => {
        const checked = group.querySelector('.box__option.is_checked:not(.box__option--empty)');
        return checked ? checked.textContent.trim() : null;
      });
      
      // KLUCZOWE: Dodaj nakład z głównego produktu do kombinacji
      const selectedWithQty = window.main_product_qty_variant 
        ? [...selected, window.main_product_qty_variant.toString()]
        : selected;
      
      // Dodaj tylko kompletne kombinacje (wszystkie opcje wybrane)
      if (selected.length === allGroups.length && selected.every(Boolean)) {
        window.log(`Używana kombinacja z customizacji ${otherCustomisationId}:`, selected, '+ nakład:', window.main_product_qty_variant, '= pełna:', selectedWithQty);
        usedCombinations.push({
          combination: selectedWithQty, // Używamy kombinacji Z nakładem!
          customisationId: otherCustomisationId
        });
      }
    });

    window.log('Wszystkie używane kombinacje (z nakładem):', usedCombinations);

    // Waliduj opcje dla konkretnej customizacji lub wszystkich
    const targetCustomisations = customisationId 
      ? [document.querySelector(`.customisation[data-id="${customisationId}"]`)].filter(Boolean)
      : customisations;

    targetCustomisations.forEach(customisation => {
      const container = customisation.querySelector('.customisation__options');
      if (!container) return;
      
      const currentCustomisationId = customisation.getAttribute('data-id');
      const allGroups = [...container.querySelectorAll('.box__options')];
      
      window.log(`Walidacja customizacji ${currentCustomisationId}, grup opcji: ${allGroups.length}`);
      
      // Pobierz aktualnie wybrane wartości w TEJ customizacji
      const currentSelected = allGroups.map(group => {
        const checked = group.querySelector('.box__option.is_checked:not(.box__option--empty)');
        return checked ? checked.textContent.trim() : null;
      });
      
      window.log('Aktualnie wybrane w tej customizacji:', currentSelected);

      // Waliduj każdą grupę opcji
      allGroups.forEach((group, groupIndex) => {
        const options = group.querySelectorAll('.box__option:not(.box__option--empty)');
        
        window.log(`Grupa ${groupIndex}, opcji: ${options.length}`);
        
        options.forEach(option => {
          const isCurrentlyChecked = option.classList.contains('is_checked');
          const optionValue = option.textContent.trim();
          
          // Jeśli opcja jest aktualnie zaznaczona, zawsze pozostaw ją aktywną
          if (isCurrentlyChecked) {
            option.classList.add('is_active');
            option.classList.remove('is_disabled');
            return;
          }
          
          // Jeśli opcja została już wyłączona przez disableUsedPlaces(), sprawdź czy to miejsce
          const wasDisabledByPlaceLogic = option.classList.contains('is_disabled');
          
          try {
            const combinations = JSON.parse(option.dataset.combinations.replace(/'/g, '"'));
            const ids = JSON.parse(option.dataset.ids || '[]');
            
            window.log(`Sprawdzam opcję "${optionValue}" w grupie ${groupIndex}, kombinacji: ${combinations.length}`);
            
            // Sprawdź czy opcja ma JAKĄKOLWIEK dostępną kombinację
            let hasAvailableCombination = false;
            
            for (let comboIndex = 0; comboIndex < combinations.length; comboIndex++) {
              const combo = combinations[comboIndex];
              const variantId = ids[comboIndex];
              
              // 1. Sprawdź czy kombinacja zawiera tę opcję na właściwej pozycji
              if (combo[groupIndex] !== optionValue) continue;
              
              // 2. Sprawdź czy wariant istnieje
              if (!variantId) {
                window.log(`  Kombinacja ${JSON.stringify(combo)} - brak variant ID`);
                continue;
              }
              
              // KLUCZOWE: Sprawdź czy kombinacja pasuje do nakładu z głównego produktu
              if (window.main_product_qty_variant && combo.length >= 3) {
                const comboQty = combo[combo.length - 1]; // Ostatni element to nakład
                if (comboQty !== window.main_product_qty_variant.toString()) {
                  window.log(`  Kombinacja ${JSON.stringify(combo)} ma inny nakład: "${comboQty}" != "${window.main_product_qty_variant}"`);
                  continue;
                }
              }
              
              // 3. Sprawdź czy kombinacja nie jest już używana przez INNĄ customizację
              const isUsedByOther = usedCombinations.some(used => {
                // Porównuj DOKŁADNIE wszystkie elementy (włącznie z nakładem!)
                if (combo.length !== used.combination.length) return false;
                
                // Porównaj wszystkie elementy
                for (let i = 0; i < combo.length; i++) {
                  if (combo[i] !== used.combination[i]) return false;
                }
                return true;
              });
              
              if (isUsedByOther) {
                window.log(`  Kombinacja ${JSON.stringify(combo)} jest już używana`);
                continue;
              }
              
              // 4. Sprawdź czy kombinacja pasuje do już wybranych opcji w TEJ customizacji
              let isCompatible = true;
              for (let i = 0; i < allGroups.length; i++) {
                if (i === groupIndex) continue; // Pomijamy aktualną grupę
                if (!currentSelected[i]) continue; // Jeśli jeszcze nie wybrano, OK
                if (i >= combo.length) {
                  // Kombinacja nie ma tej pozycji - to problem
                  window.log(`  Kombinacja ${JSON.stringify(combo)} nie ma pozycji ${i} (potrzebna: "${currentSelected[i]}")`);
                  isCompatible = false;
                  break;
                }
                
                if (combo[i] !== currentSelected[i]) {
                  window.log(`  Kombinacja ${JSON.stringify(combo)} niezgodna na pozycji ${i}: "${combo[i]}" != "${currentSelected[i]}"`);
                  isCompatible = false;
                  break;
                }
              }
              
              if (isCompatible) {
                window.log(`  ✓ Kombinacja ${JSON.stringify(combo)} jest dostępna!`);
                hasAvailableCombination = true;
                break;
              }
            }
            
            if (hasAvailableCombination) {
              window.log(`✓ Opcja "${optionValue}" DOSTĘPNA`);
              option.classList.add('is_active');
              option.classList.remove('is_disabled');
            } else {
              window.log(`✗ Opcja "${optionValue}" NIEDOSTĘPNA (brak pasujących kombinacji)`);
              option.classList.remove('is_active');
              option.classList.add('is_disabled');
            }
          } catch (e) {
            console.error('Błąd walidacji dla opcji:', optionValue, e);
          }
        });
      });
    });
    
    window.log('=== validateAvailableCombinations END ===');
  },

  updateCdrawerBundle: (customisation_id) => {
    // console.log('window.cdrawer.updateCdrawerBundle()');

    ['1', '2', '3', '4', '5'].forEach(key => {
      delete window.cdrawer_bundle[key];
    });

    const customisations = document.querySelectorAll('#cdrawer .customisation');
    let customisations_is_set = [];
    
    if (customisations.length) {
      customisations.forEach((customisation, index) => {
        const id = customisation.getAttribute('data-id');
        const input_variant = customisation.querySelector('input[name*="_variant_id"]');
        const input_file = customisation.querySelector('input[name*="_file"]');
        let is_set = false;
        let is_set_without_file = false;

        if (input_variant.value != '' && input_file?.files?.length > 0) {
          is_set = true;
        }

        if (input_variant.value != '' &&  input_file?.files?.length === 0) {
          is_set_without_file = true;
        }

        if (is_set == true) {
          
          customisations_is_set.push(true);
          window.cdrawer_bundle[`${id}`] = {
            is_set: is_set, 
            is_set_without_file: is_set_without_file, 
            variant_id: input_variant.value,
            price: parseFloat(window.cdrawer.searchProductVariantPrice(input_variant.value))
          };

        } else if (is_set_without_file == true) {
          
          customisations_is_set.push(false);
          window.cdrawer_bundle[`${id}`] = {
            is_set: is_set, 
            is_set_without_file: is_set_without_file, 
            variant_id: input_variant.value,
            price: parseFloat(window.cdrawer.searchProductVariantPrice(input_variant.value))
          };
        
        } else {
          customisations_is_set.push(false);
        }
      }); 
    }

    window.cdrawer.setCustomisationStatus();
    window.cdrawer.updateCdrawerBundleSummary();
  },

  disableUsedPlaces: () => {
    const usedCombinations = [];
    const usedPlaces = [];
    const customisations = document.querySelectorAll('#cdrawer .customisation.is_active');
    
    if (!customisations.length) return;
    
    customisations.forEach(customisation => {
      const customisationId = customisation.getAttribute('data-id');
      const placeBox = customisation.querySelector('.box--place');
      const typeBox = customisation.querySelector('.box--type');
      
      let selectedPlace = null;
      let selectedType = null;
      
      if (placeBox) {
        const checkedOption = placeBox.querySelector('.box__option.is_checked:not(.box__option--empty)');
        if (checkedOption) {
          selectedPlace = checkedOption.textContent.trim();
          usedPlaces.push({ place: selectedPlace, customisationId });
        }
      }
      
      if (typeBox) {
        const checkedOption = typeBox.querySelector('.box__option.is_checked:not(.box__option--empty)');
        if (checkedOption) {
          selectedType = checkedOption.textContent.trim();
        }
      }
      
      if (selectedPlace && selectedType) {
        usedCombinations.push({
          place: selectedPlace,
          type: selectedType,
          customisationId
        });
      }
    });

    customisations.forEach(customisation => {
      if (!customisation) return;
      
      const customisationId = customisation.getAttribute('data-id');
      const placeBox = customisation.querySelector('.box--place');
      const typeBox = customisation.querySelector('.box--type');
      
      let currentSelectedType = null;
      if (typeBox) {
        const checkedTypeOption = typeBox.querySelector('.box__option.is_checked:not(.box__option--empty)');
        if (checkedTypeOption) {
          currentSelectedType = checkedTypeOption.textContent.trim();
        }
      }
      
      if (placeBox) {
        const placeOptions = placeBox.querySelectorAll('.box__option:not(.box__option--empty)');
        
        placeOptions.forEach(option => {
          if (!option) return;
          
          const place = option.textContent.trim();
          const isCurrentlyChecked = option.classList.contains('is_checked');
          
          const isUsedByOther = usedPlaces.some(used => 
            used.place === place && used.customisationId !== customisationId
          );
          
          if (isUsedByOther) {
            option.classList.remove('is_active');
            option.classList.add('is_disabled');
          } else if (currentSelectedType) {
            let placeHasCombinationWithSelectedType = false;
            
            if (typeBox) {
              const typeOptions = typeBox.querySelectorAll('.box__option:not(.box__option--empty)');
              for (const typeOption of typeOptions) {
                if (!typeOption.dataset || !typeOption.dataset.combinations) continue;
                
                try {
                  const combinations = JSON.parse(typeOption.dataset.combinations.replace(/'/g, '"'));
                  const typeName = typeOption.textContent.trim();
                  
                  if (typeName === currentSelectedType) {
                    placeHasCombinationWithSelectedType = combinations.some(combo => {
                      const comboPlace = combo[0];
                      const comboType = combo[1];
                      
                      if (comboPlace !== place || comboType !== currentSelectedType) return false;
                      
                      const isComboUsed = usedCombinations.some(used => 
                        used.place === comboPlace && 
                        used.type === comboType && 
                        used.customisationId !== customisationId
                      );
                      
                      return !isComboUsed;
                    });
                    break;
                  }
                } catch (e) {
                  console.warn('Błąd parsowania kombinacji dla miejsca:', e);
                }
              }
            }
            
            if (!placeHasCombinationWithSelectedType && !isCurrentlyChecked) {
              option.classList.remove('is_active');
              option.classList.add('is_disabled');
            } else {
              if (!isCurrentlyChecked) {
                option.classList.add('is_active');
                option.classList.remove('is_disabled');
              }
            }
          } else {
            if (!isCurrentlyChecked) {
              option.classList.add('is_active');
              option.classList.remove('is_disabled');
            }
          }
        });
      }
      
      if (typeBox) {
        const typeOptions = typeBox.querySelectorAll('.box__option:not(.box__option--empty)');
        
        let currentSelectedPlace = null;
        if (placeBox) {
          const checkedPlaceOption = placeBox.querySelector('.box__option.is_checked:not(.box__option--empty)');
          if (checkedPlaceOption) {
            currentSelectedPlace = checkedPlaceOption.textContent.trim();
          }
        }
        
        typeOptions.forEach(option => {
          if (!option || !option.dataset || !option.dataset.combinations) return;
          
          try {
            const combinations = JSON.parse(option.dataset.combinations.replace(/'/g, '"'));
            const typeName = option.textContent.trim();
            const isCurrentlyChecked = option.classList.contains('is_checked');
            const hasAvailableCombination = combinations.some(combo => {
              const comboPlace = combo[0];
              const comboType = combo[1];
              
              if (currentSelectedPlace && comboPlace !== currentSelectedPlace) {
                return false;
              }
              
              const isComboUsed = usedCombinations.some(used => 
                used.place === comboPlace && 
                used.type === comboType && 
                used.customisationId !== customisationId
              );
              
              return !isComboUsed;
            });
            
            if (!hasAvailableCombination && !isCurrentlyChecked) {
              option.classList.remove('is_active');
              option.classList.add('is_disabled');
            } else {
              if (!isCurrentlyChecked) {
                option.classList.add('is_active');
                option.classList.remove('is_disabled');
              }
            }
          } catch (e) {
            console.warn('Błąd parsowania kombinacji:', e);
          }
        });
      }
    });
  },

  updateCdrawerActions: () => {
    const crdawer = document.querySelector('#cdrawer');

    crdawer.querySelectorAll('.box__options').forEach(group => {
      group.addEventListener('click', event => {
        const clicked = event.target.closest('.box__option:not(.box__option--empty)');
        if (!clicked) return;
        
        // BLOKADA: Zablokuj kliknięcie na wyłączone opcje
        if (clicked.classList.contains('is_disabled')) {
          window.log('Kliknięto wyłączoną opcję - ignoruję');
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const customisation = clicked.closest('.customisation');
        if (!customisation) return;
        
        const customisation_id = customisation.getAttribute('data-id');
        const container = clicked.closest('.customisation__options');
        if (!container) return;
        
        const allGroups = [...container.querySelectorAll('.box__options')];


        const parentBox = clicked.closest('.box__options');
        if (!parentBox) return;

        const isAlreadyChecked = clicked.classList.contains('is_checked');
        const fileInput = customisation.querySelector('input[name*="_file"]');
        const hasFile = fileInput?.files?.length > 0;

        if (isAlreadyChecked && !hasFile) {
          clicked.classList.remove('is_checked');
          allGroups.forEach(group => {
            group.querySelectorAll('.box__option:not(.box__option--empty)').forEach(opt => opt.classList.add('is_active'));
          });
          const variantInput = container.querySelector('input[name*="variant_id"]');
          if (variantInput) variantInput.value = '';
          window.cdrawer.disableUsedPlaces();
          window.cdrawer.validateAvailableCombinations(customisation_id);
          window.cdrawer.checkAllCustomisations(customisation_id);
          window.cdrawer.updateCdrawerBundle(customisation_id);
          window.cdrawer.updateShowResetButton(customisation_id);
          return;
        }

        parentBox.querySelectorAll('.box__option').forEach(opt => opt.classList.remove('is_checked'));
        clicked.classList.add('is_checked');

        const selected = allGroups.map(group => {
          const checked = group.querySelector('.box__option.is_checked:not(.box__option--empty)');
          return checked ? checked.textContent.trim() : null;
        });

        allGroups.forEach((group, groupIndex) => {
          group.querySelectorAll('.box__option:not(.box__option--empty)').forEach(opt => {
            const combinations = JSON.parse(opt.dataset.combinations.replace(/'/g, '"'));
            const optionValue = opt.textContent.trim();

            const isValid = combinations.some(combo =>
              combo[groupIndex] === optionValue &&
              combo.every((val, i) => {
                if (i === groupIndex) return true;
                return !selected[i] || selected[i] === val;
              })
            );

            opt.classList.toggle('is_disabled', !isValid);
          });
        });

        window.cdrawer.disableUsedPlaces();
        window.cdrawer.validateAvailableCombinations(customisation_id);
        window.cdrawer.checkAllCustomisations(customisation_id);
        window.cdrawer.updateCdrawerBundle(customisation_id);
        window.cdrawer.updateShowResetButton(customisation_id);
      });
    });

    document.querySelectorAll('.customisation__reset').forEach(btn => {
      btn.addEventListener('click', () => {
        const customisation = btn.closest('.customisation');
        if (!customisation) return;
        
        const id = customisation.getAttribute('data-id');
        window.cdrawer.resetCustomisation(id);
        window.cdrawer.checkAllCustomisations();
        window.cdrawer.setCustomisationStatus();
        window.cdrawer.disableUsedPlaces();
        window.cdrawer.validateAvailableCombinations();
      });
    });

    crdawer.querySelectorAll('.customisation .box--file').forEach(box => {
      const dropzone = box.querySelector('.box__content__dropzone');
      const fileInput = box.querySelector('input[type="file"]');
      const customisation = box.closest('.customisation');
      
      if (!dropzone || !fileInput || !customisation) return;
      
      const customisation_id = customisation.getAttribute('data-id');
      const allowedFileTypes = fileInput.getAttribute('accept') || '.jpg,.jpeg,.png,.pdf,.eps,.ai';

      fileInput.removeAttribute('multiple');
      if (!fileInput.getAttribute('accept')) {
        fileInput.setAttribute('accept', allowedFileTypes);
      }

      dropzone.addEventListener('click', () => fileInput.click());

      dropzone.addEventListener('dragover', (e) => {
        e.preventDefault();
        dropzone.classList.add('is_dragover');
      });

      dropzone.addEventListener('dragleave', () => {
        dropzone.classList.remove('is_dragover');
      });

      dropzone.addEventListener('drop', (e) => {
        e.preventDefault();
        dropzone.classList.remove('is_dragover');

        const files = e.dataTransfer.files;
        if (files.length > 0) {
          const dt = new DataTransfer();
          dt.items.add(files[0]);
          fileInput.files = dt.files;

          handleFile(files[0], box);
        }
        window.cdrawer.setCustomisationStatus();
        window.cdrawer.checkAddNewCustomisation('scroll_to_end');
        window.cdrawer.checkAllCustomisations();
        window.cdrawer.updateCdrawerBundle();
        window.cdrawer.updateShowResetButton(customisation_id);
      });

      fileInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (file) {
          handleFile(file, box);
        }
        window.cdrawer.setCustomisationStatus();
        window.cdrawer.checkAddNewCustomisation('scroll_to_end');
        window.cdrawer.checkAllCustomisations();
        window.cdrawer.updateCdrawerBundle();
        window.cdrawer.updateShowResetButton(customisation_id);
      });

      function handleFile(file, box) {
        const acceptAttr = fileInput.getAttribute('accept') || '';
        const allowedExtensions = acceptAttr
          .split(',')
          .map(ext => ext.trim().replace('.', '').toLowerCase())
          .filter(Boolean);
        
        const ext = file.name.split('.').pop().toLowerCase();
        const customisationId = box.closest('.customisation')?.dataset.id ?? 'brak-id';

        if (allowedExtensions.length > 0 && !allowedExtensions.includes(ext)) {
          alert(`Nieobsługiwany typ pliku: ${file.name}`);
          return;
        }

        // console.log(`[${customisationId}] Dodano plik:`, file.name);
        dropzone.textContent = file.name;
      }
    });
  },

  open: () => {
    const cdrawer = document.querySelector('#cdrawer');
    if (cdrawer) {
      cdrawer.classList.add('is-open');
      document.body.classList.add('js-cdrawer-open');

      window.main_product_qty_variant = document.querySelector('.product-single__details .product_qty_group [type="radio"]:checked') ? document.querySelector('.product-single__details .product_qty_group [type="radio"]:checked').value : false;

      window.log('cdrawer.open() - nakład z głównego produktu:', window.main_product_qty_variant);
      
      // Wykonaj walidację po otwarciu (z uwzględnieniem nakładu)
      setTimeout(() => {
        window.cdrawer.validateAvailableCombinations();
      }, 100);
    }
  },

  close: () => {
    const cdrawer = document.querySelector('#cdrawer');
    if (cdrawer) {
      cdrawer.classList.remove('is-open');
      document.body.classList.remove('js-cdrawer-open');
    }
  }

};

try { window.cdrawer.init(); } catch (err) { console.error('cdrawer.init:', err); }


window.ccart = {

  init: () => {
    window.ccart.setupEventDelegation();
  },

  setupEventDelegation: () => {
    document.addEventListener('click', (e) => {
      const removeBundleBtn = e.target.closest('[data-action-remove-bundle-id]');
      if (removeBundleBtn) {
        const bundleId = removeBundleBtn.getAttribute('data-action-remove-bundle-id');
        if (bundleId && bundleId !== 'false') {
          e.preventDefault();
          e.stopPropagation();
          // console.log('debug: removing entire bundle', bundleId);
          window.ccart.removeItemByBundleId(bundleId);
          return;
        }
      }

      const removeItemBtn = e.target.closest('[data-action-remove-line-item-key]');
      if (removeItemBtn) {
        e.preventDefault();
        e.stopPropagation();
        const line_item_key = removeItemBtn.getAttribute('data-action-remove-line-item-key');
        // console.log('debug: removing single item', line_item_key);
        const icustoms = removeItemBtn.closest('.icustoms');
        
        if (icustoms) {
          const icustoms_items = icustoms.querySelectorAll('.icustom');
          if (icustoms_items.length == 1) {
            const remove_bundle_button = removeItemBtn.closest('.cart__item').querySelector('[data-action-remove-bundle-id]');
            if (remove_bundle_button) {
              const bundleId = remove_bundle_button.getAttribute('data-action-remove-bundle-id');
              if (bundleId && bundleId !== 'false') {
                remove_bundle_button.click();
              } else {
                window.ccart.removeItemByLineItemKey(line_item_key);
              }
            } else {
              window.ccart.removeItemByLineItemKey(line_item_key);
            }
          } else {
            window.ccart.removeItemByLineItemKey(line_item_key);
          }
        } else {
          window.ccart.removeItemByLineItemKey(line_item_key);
        }
        return;
      }
    }); 
  },
  updateCartIcon: () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartToggleButtons = document.querySelectorAll('.cart__toggle');
        const itemCount = cart.item_count;
        
        cartToggleButtons.forEach(button => {
          if (itemCount > 0) {
            button.classList.add('cart__toggle--has-items');
          } else {
            button.classList.remove('cart__toggle--has-items');
          }
          
          const countEl = button.querySelector('[data-cart-count]');
          if (countEl) {
            countEl.textContent = itemCount;
          }
          
          // Dodaj event listener jeśli jeszcze go nie ma
          if (!button.hasAttribute('data-custom-cart-listener')) {
            button.addEventListener('click', (e) => {
              e.preventDefault();
              const cartDrawer = document.querySelector('#cart-drawer');
              const isOpen = document.body.classList.contains('js-drawer-open-cart');
              
              if (isOpen) {
                document.body.classList.remove('js-drawer-open-cart');
                if (cartDrawer) {
                  cartDrawer.classList.remove('is-open');
                }
                button.setAttribute('aria-expanded', 'false');
              } else {
                document.body.classList.add('js-drawer-open-cart');
                if (cartDrawer) {
                  cartDrawer.classList.add('is-open');
                }
                button.setAttribute('aria-expanded', 'true');
              }
            });
            button.setAttribute('data-custom-cart-listener', 'true');
          }
        });
      });
  },

  revealAosItems: (container) => {
    // Po ręcznej podmianie HTML koszyka motyw nie dokłada klasy 'aos-animate',
    // więc elementy [data-aos] zostają w stanie początkowym (opacity .001 / przesunięte).
    // Odtwarzamy zachowanie motywu (CartDrawer.animateCartItems('in')).
    if (!container) return;
    container.querySelectorAll('[data-aos]').forEach((item) => {
      requestAnimationFrame(() => item.classList.add('aos-animate'));
    });
  },

  reload: () => {
    const cart_section_el = document.querySelector('section[data-section-type="cart-template"]');
    const cart_drawer_el = document.querySelector('#cart-drawer');
    
    if (cart_section_el) {
      // console.log('reload - cart_section_el')

      cart_section_el.querySelector('[data-cart-form]').classList.add('is-loading');
      const section_id = cart_section_el.dataset.sectionId;

      fetch(`/cart?sections=${section_id}`)
      .then((res) => res.json())
      .then((data) => {
        const html = data[section_id];
        if (!html) return;

        const temp_div = document.createElement('div');
        temp_div.innerHTML = html;

        const new_inner = temp_div.querySelector('.cart__inner');
        const old_inner = cart_section_el.querySelector('.cart__inner');

        if (new_inner && old_inner) {
          old_inner.replaceWith(new_inner);

          window.ccart.revealAosItems(new_inner);

          const cart_drawer_el = document.querySelector('#cart-drawer');
          if (cart_drawer_el) {
            cart_drawer_el.classList.remove('is-loading');
          }

          const cart_page_form_el = document.querySelector('[data-tpl="cart"] [data-cart-form]');
          if (cart_page_form_el) {
            cart_page_form_el.classList.remove('is-loading');
          }
          
          window.ccart.updateCartIcon();

          setTimeout(() => {
            window.ccart.cleanOrphanedCustomisations();
          }, 1000);
        }
      });
    } 

    if (cart_drawer_el) {
      // console.log('reload - cart_drawer_el')
      cart_drawer_el.classList.add('is-loading');

      fetch('/')
        .then(res => res.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          const newTemplate = tempDiv.querySelector('template[data-cart-drawer-template]');
          if (!newTemplate || !newTemplate.content) return;

          const newContent = newTemplate.content.cloneNode(true);
          cart_drawer_el.innerHTML = ''; // wyczyść stary koszyk
          cart_drawer_el.appendChild(newContent);
          
          // console.log('[Cart] #cart-drawer content updated from template');

          setTimeout(()=>{
            // Uwaga: #cartDrawerEmptyMessage jest ZAWSZE w DOM — przy niepustym koszyku
            // ma tylko klasę 'hidden'. Dlatego o pustym koszyku decyduje BRAK klasy 'hidden',
            // a nie samo istnienie elementu.
            const empty_message = cart_drawer_el.querySelector('#cartDrawerEmptyMessage');
            const is_cart_empty = empty_message && !empty_message.classList.contains('hidden');
            if (is_cart_empty) {
              window.ccart.addThemeEvents('cart_is_empty',30011);
            } else {
              window.ccart.addThemeEvents('cart_is_not_empty',40012);
              document.dispatchEvent(new CustomEvent('theme:cart:added', {bubbles: true}));
              window.ccart.revealAosItems(cart_drawer_el);
            }

            window.ccart.updateCartIcon();

            setTimeout(() => {
              window.ccart.cleanOrphanedCustomisations();
            }, 1000);
          }, 300);
          
        })
        .catch(err => console.error('Cart drawer reload failed:', err))
        .finally(() => {
          cart_drawer_el.classList.remove('is-loading');
        });
    }
  },

  cleanOrphanedCustomisations: () => {
    // console.log('cleanOrphanedCustomisations - START');
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // console.log('Cart data received:', cart);
        // console.log('Cart items count:', cart.items.length);
        
        const updates = {};
        const bundleCounts = [];
        
        cart.items.forEach(item => {
          const props = item.properties || {};
          const zestawId = props.zestaw;
          
          if (zestawId) {
            let found = bundleCounts.find(b => b.zestaw === zestawId);
            if (!found) {
              found = { zestaw: zestawId, exists: 0, items: [] };
              bundleCounts.push(found);
            }
            found.exists++;
            found.items.push(item.key);
          }
        });

        // console.log('Bundle counts:', bundleCounts);

        bundleCounts.forEach(bundle => {
          if (bundle.exists === 1) {
            window.log(`Orphaned bundle found: ${bundle.zestaw} (exists: ${bundle.exists})`);
            bundle.items.forEach(itemKey => {
              updates[itemKey] = 0;
            });
          }
        });

        if (Object.keys(updates).length > 0) {
          window.log('Removing orphaned items:', updates);
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          }).then(() => {
            setTimeout(() => {
              window.ccart.reload();
            }, 300);
          });
        }
      });
  },

  removeItemByLineItemKey: (key) => {
    // console.log(`window.ccart.removeItemByLineItemKey(${key})`);

    const cart_page_form_el = document.querySelector('[data-tpl="cart"] [data-cart-form]');
    const cart_drawer_el = document.querySelector('#cart-drawer');

    if (cart_page_form_el) {
      cart_page_form_el.classList.add('is-loading');
    } else if (cart_drawer_el) {
      cart_drawer_el.classList.add('is-loading');
    }

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const updates = {};

        cart.items.forEach(item => {
          if (item.key == key) {
            updates[item.key] = 0;
          }
        });

        // console.log('updates', updates)

        if (Object.keys(updates).length > 0) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          }).then(() => {
            window.ccart.reload();
          });
        }
      });    
  },

  removeItemByBundleId : (id) => {
    // console.log(`window.ccart.removeItemByBundleId(${id})`);

    const cart_page_form_el = document.querySelector('[data-tpl="cart"] [data-cart-form]');
    const cart_drawer_el = document.querySelector('#cart-drawer');
    
    if (cart_page_form_el) {
      cart_page_form_el.classList.add('is-loading');  
    } else if (cart_drawer_el) {
      cart_drawer_el.classList.add('is-loading');
    }
    
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const updates = {};

        cart.items.forEach(item => {
          const props = item.properties || {};
          const hasMatchingValue = Object.values(props).some(value => value == id);

          if (hasMatchingValue) {
            updates[item.key] = 0;
          }
        });

        // console.log('updates', updates)

        if (Object.keys(updates).length > 0) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          }).then(() => {
            window.ccart.reload();
          });
        }
      });    
  },

  addThemeEvents: (info, debug) => {
    // console.log(`window.ccart.addThemeEvents(${info}) ${debug}`);
    
    const drawer_overlay_el = document.querySelector('#SiteHeader .drawer__overlay');
    if (drawer_overlay_el) {
      const hasClickListener = drawer_overlay_el._listenerAttached === true;
      if (!hasClickListener) {
        drawer_overlay_el.addEventListener('click', () => {
          document.body.classList.remove('js-drawer-open-cart');
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        });

        drawer_overlay_el._listenerAttached = true;
        drawer_overlay_el.classList.add('event_is_set');
      }
    }

    let cart_drawer_close_el = document.querySelector('#cart-drawer .cart-drawer__close:not(.event_is_set)');
    if (cart_drawer_close_el) {
      cart_drawer_close_el.addEventListener('click', () => {
        document.body.classList.remove('js-drawer-open-cart');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      });
      cart_drawer_close_el.classList.add('event_is_set');
    }

    let cart_widget_title_el = document.querySelector('#cart-drawer .cart__widget__title:not(.event_is_set)');
    if (cart_widget_title_el) {
      cart_widget_title_el.addEventListener('click', (e) => {
        if (e.currentTarget.classList.contains('is-expanded')){
          e.currentTarget.classList.remove('is-expanded');
          e.currentTarget.setAttribute('aria-expanded', 'false');
          const notes = document.querySelector('#cart-drawer #notes');
          if (notes) {
            notes.classList.remove('is-expanded');
            notes.style.height = '';
          }
        } else {
          e.currentTarget.classList.add('is-expanded');
          e.currentTarget.setAttribute('aria-expanded', 'true');
          const notes = document.querySelector('#cart-drawer #notes');
          if (notes) {
            notes.classList.add('is-expanded');
            notes.style.height = 'auto';
          }
        }
      });
      cart_drawer_close_el.classList.add('event_is_set');
    }
  },

};


try { window.ccart.init(); } catch (err) { console.error('ccart.init:', err); }

window.addEventListener('load', () => {
  setTimeout(() => {
    window.ccart.cleanOrphanedCustomisations();
  }, 500);
});

const cartObserver = new MutationObserver(() => {
  window.ccart.cleanOrphanedCustomisations();
});

const cartDrawer = document.querySelector('#cart-drawer');
if (cartDrawer) {
  cartObserver.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}

const cartSection = document.querySelector('section[data-section-type="cart-template"]');
if (cartSection) {
  cartObserver.observe(cartSection, {
    childList: true,
    subtree: true
  });
}
